import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import Slide from '@material-ui/core/Slide';
import { compose } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import withUser from '../HOC/HOCwithUser.jsx';
import HOCSectionLoader from '../HOC/HOCSectionLoader';
import withCustomTheme from '../HOC/HOCwithCustomTheme.jsx';
import { Redirect, withRouter } from 'react-router-dom';
import {
    Table,
    TableRow,
    TableCell,
    TableHead,
    TableBody,
    TextField,
    CircularProgress
} from '@material-ui/core';
import Card from 'react-credit-cards';
import { withTheme } from '@material-ui/core/styles';
import AddNewCard from '../Booking/AddNewCard.jsx';
import SavedCards from '../Booking/SavedCards';
import { NotificationManager } from 'react-notifications';
import { FormattedMessage, injectIntl } from 'react-intl';
const styles = {
    appBar: {
        position: 'relative'
    },
    flex: {
        flex: 1
    }
};

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class AddWalletMoneyForm extends React.Component {
    constructor() {
        super();
        this.state = {
            showAddPopup: false,
            loaderButton: false,
            acceptLoadingButton: false,
            amount: 300,
            isPayClick: ''
        };
    }
    componentDidMount() {
        this.getData();
    }
    getData = () => {
        this.props.walletListAction();
    };
    renderAddAmount = () => {
        this.setState({ showAddPopup: true });
    };

    payViaCard = cardId => {
        this.setState({ isPayClick: cardId });
        this.props.walletAmountAddAction(
            {
                cardId,
                amount: this.state.amount
            },
            this.onPaymentDone
        );
    };
    handleClose = () => {
        this.setState({ showAddPopup: false });
        this.props.backToList();
    };
    onPaymentDone = (success, data) => {
        this.setState({ isPayClick: '' });
        if (success) {
            NotificationManager.success(data.message, 'Success');
            this.handleClose();
        } else {
            NotificationManager.error(data.message, 'Error');
        }
    };
    refreshList = () => {
        this.getData();
    };
    render() {
        const { walletData, settings } = this.props;
        const { amount, amountError } = this.state;

        return (
            <div>
                <HOCSectionLoader loading={this.props.walletLoader}>
                    <List>
                        <ListItem className="wallet-list">
                            <ListItemText
                                className="wallet-list-text"
                                primary="Balance"
                                secondary={
                                    settings.constants.CURRENCY_SYMBOL +
                                    ' ' +
                                    walletData.balance
                                }
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => this.handleClose()}
                            >
                                <FormattedMessage
                                    id="walletList"
                                    defaultMessage="Wallet List"
                                />
                            </Button>

                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={() => this.renderAddAmount()}
                            >
                                <FormattedMessage
                                    id="addAmount"
                                    defaultMessage="Add Amount"
                                />
                            </Button>
                        </ListItem>
                        <Divider />
                    </List>
                    <div className="">
                        {!this.state.showAddPopup ? (
                            <div className="tz-db-table">
                                <Table className="table bordered">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                <FormattedMessage
                                                    id="transactionAmount"
                                                    defaultMessage="Transaction Amount"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <FormattedMessage
                                                    id="heading"
                                                    defaultMessage="Heading"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <FormattedMessage
                                                    id="balance"
                                                    defaultMessage="Balance"
                                                />
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {walletData.transactions &&
                                            walletData.transactions.map(
                                                transaction => {
                                                    return (
                                                        <TableRow
                                                            key={
                                                                transaction.key
                                                            }
                                                        >
                                                            <TableCell>
                                                                {settings
                                                                    .constants
                                                                    .CURRENCY_SYMBOL +
                                                                    ' ' +
                                                                    transaction.amount}
                                                            </TableCell>
                                                            <TableCell>
                                                                {
                                                                    transaction.heading
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {settings
                                                                    .constants
                                                                    .CURRENCY_SYMBOL +
                                                                    ' ' +
                                                                    transaction.closing_balance}
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                }
                                            )}
                                    </TableBody>
                                </Table>
                            </div>
                        ) : (
                            <div>
                                <div className="form-new">
                                    <TextField
                                        error={amountError ? true : false}
                                        helperText={amountError}
                                        label="Enter Amount"
                                        id="amount"
                                        className="login-form-textfield "
                                        fullWidth={true}
                                        name="amount"
                                        type="text"
                                        value={amount}
                                        onChange={event => {
                                            this.setState({
                                                amount: event.target.value,
                                                amountError: ''
                                            });
                                        }}
                                        title="Enter the amount you want to add to your wallet"
                                    />

                                    {/* {this.renderButton()} */}
                                </div>
                                <br />
                                <div>
                                    <HOCSectionLoader
                                        loading={this.props.cardLoader}
                                    >
                                        <SavedCards
                                            payViaCard={cardId =>
                                                this.payViaCard(cardId)
                                            }
                                            isButtonLoading={
                                                this.state.isPayClick
                                            }
                                        />
                                    </HOCSectionLoader>
                                    <AddNewCard
                                        redirectToList={this.refreshList}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </HOCSectionLoader>
            </div>
        );
    }
}

AddWalletMoneyForm.propTypes = {
    // classes: PropTypes.object.isRequired
};
const mapStateToProps = ({ wallet }) => {
    return {
        walletData: wallet.walletData,
        walletLoader: wallet.walletLoader
    };
};
const composedComponent = compose(
    withTheme(),
    withStyles(styles),
    connect(mapStateToProps, actions)
);

export default composedComponent(
    withUser(withCustomTheme(withRouter(AddWalletMoneyForm)))
);



// WEBPACK FOOTER //
// ./src/components/Customer/AddWalletMoneyForm.jsx